import React, { useState } from "react"
import { useDispatch } from "react-redux"
import { Pagination, PaginationItem, PaginationLink } from "reactstrap"

const PaginationComponent = ({ totalPages, currentPage, setCurrentPage }) => {
  const dispatch = useDispatch()
  const [currentPageGroup, setCurrentPageGroup] = useState(0)

  const pagesPerGroup = 5
  const startPage = currentPageGroup * pagesPerGroup + 1
  const endPage = Math.min(startPage + pagesPerGroup - 1, totalPages)

  const handleClickPage = (page) => {
    dispatch(setCurrentPage(page))
    console.log("Page sélectionnée :", page)
  }

  const handlePrevGroup = () => {
    if (startPage > 1) {
      setCurrentPageGroup(currentPageGroup - 1)
    }
  }

  const handleNextGroup = () => {
    if (endPage < totalPages) {
      setCurrentPageGroup(currentPageGroup + 1)
    }
  }

  const renderPages = () => {
    const pages = []
    for (let page = startPage; page <= endPage; page++) {
      pages.push(
        <PaginationItem active={page === currentPage} key={page}>
          <PaginationLink onClick={() => handleClickPage(page)}>
            {page}
          </PaginationLink>
        </PaginationItem>
      )
    }
    return pages
  }

  return (
    <Pagination className="mt-4">
      <PaginationItem disabled={startPage === 1}>
        <PaginationLink previous onClick={handlePrevGroup} />
      </PaginationItem>

      {renderPages()}

      <PaginationItem disabled={endPage === totalPages}>
        <PaginationLink next onClick={handleNextGroup} />
      </PaginationItem>
    </Pagination>
  )
}

export default PaginationComponent
